module.exports = __webpack_public_path__ + "img/15.f00b70e8.png";